import styled from 'styled-components';
import {Card} from "react-bootstrap"
import CardBodyContainer from "../../../common/styles/CardBodyContainer"
import {usePopularBooks} from "../../community/popular-books/usePopularBooks"
import PopularBookListRowLoading from '../../community/popular-books/PopularBookListRowLoading';
import PopularBookListRow from '../../community/popular-books/PopularBookListRow';
import CardTitle from '../../../common/styles/CardTitle';
import BooksitoutLogo from '../../../common/BooksitoutLogo';
import NoContent from '../../../common/NoContent';

const IndexPopularBookCard = () => {
    const [isLoading, popularBooks] = usePopularBooks(10)

    return (
        <Card>
            <CardBodyContainer>
                <CardTitle
                    icon={<BooksitoutLogo/>}
                    title='책잇아웃 베스트셀러'
                    subTitle='유명 서점의 베스트 셀러를 종합한 순위에요'
                    url='/community/popular-books'
                />

                {isLoading ? (
                    <Row>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(index =>
                            <Col key={index}>
                                <PopularBookListRowLoading index={index}/>
                            </Col>
                        )}
                    </Row>
                ) : popularBooks.length === 0 ? (
                    <NoContentCenter>
                        <NoContent message={'베스트셀러 정보를 불러올 수 없어요'} />
                    </NoContentCenter>
                ) : (
                    <Row>
                        {popularBooks.map(book =>
                            <Col key={book.isbn}>
                                <PopularBookListRow popularBook={book}/>
                            </Col>
                        )}
                    </Row>
                )}

            </CardBodyContainer>
        </Card>
    )
}

const Row = styled.div.attrs({
    className: 'row'
})`
`;

const Col = styled.div.attrs({
    className: 'col-12'
})`
`;

const NoContentCenter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 500px;
`;


export default IndexPopularBookCard